export function setCurrency(currency?: string | null) {
  return {
    type: "SET_CURRENCY",
    currency,
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setOption(option: string, value: any) {
  return {
    type: "SET_OPTION",
    option,
    value,
  }
}

export function toggleOption(option: string) {
  return {
    type: "TOGGLE_OPTION",
    option,
  }
}

export function setCustomerVerified(verified: boolean) {
  return {
    type: "SET_CUSTOMER_VERIFIED",
    verified,
  }
}
